import { useEffect } from 'react';
import { useInView } from 'react-intersection-observer';
import { Card } from 'react-bootstrap';
import $ from 'jquery';
import { useTranslation } from "react-i18next";
import { Markup } from 'interweave';
import { useNavigate } from "react-router-dom";

export default function NumberHeighlights(){
    const { ref, inView } = useInView({threshold:0});
    const { t } = useTranslation();
    const navigate = useNavigate();

    useEffect(()=>{
        if(inView){
            $('.counter').each(function() {
                var $this = $(this),
                    countTo = $this.attr('data-count');
                    
                $({ countNum: $this.text()}).animate({
                  countNum: countTo
                },{
                  duration: 8000,
                  easing:'linear',
                  step: function() {
                    $this.text(Math.floor(this.countNum));
                  },
                  complete: function() {
                    $this.text(this.countNum);
                  }
                });  
              });
        }
    },[inView])

    const openGptw = () => {
        navigate(`/lifeatcentrico/#gptw`);
    }

    return(
        <article>
                <section class="num-highlights" ref={ref}>
                    <div class="container">
                    <div class="row">
                        <div class="col-md-4 mb-3">
                            <div class="card-wrapper headcount-wrapper">
                                <Card className='services metrics'>
                                    <Card.Body>
                                        <div class="icon-placeholder headcount">
                                            <div class="icon"></div>
                                        </div>
                                        <div class="title"><i class="counter" style={{"font-style":"normal"}} data-count="300">0</i>+</div>
                                        <div class="sub-title">{t('home.numbers.headcount')}</div>
                                    </Card.Body>
                                </Card>
                                {/* <Card className='services chart'>
                                    <Card.Body>
                                        <section class="bar-graph bar-graph-vertical bar-graph-two">
                                            <div class="bar-one bar-container">
                                                <div class="bar" data-percentage="325+"></div>
                                                <span class="year">India</span>
                                            </div>
                                            <div class="bar-two bar-container">
                                                <div class="bar" data-percentage="350+"></div>
                                                <span class="year">Italy</span>
                                            </div>
                                            <div class="bar-three bar-container">
                                                <div class="bar" data-percentage="500+"></div>
                                                <span class="year">Romania</span>
                                            </div>
                                        </section>
                                    </Card.Body>
                                </Card> */}
                            </div>
                        </div>
                        <div class="col-md-4 mb-3">
                        <div class="card-wrapper">
                            <div class="card services">
                            <div class="icon-placeholder applications">
                                <div class="icon"></div>
                            </div>
                            <div class="title"><i class="counter" style={{"font-style":"normal"}} data-count="78">0</i>%</div>
                            <div class="sub-title"><Markup content={t('home.numbers.applications')}></Markup></div>
                            </div>
                        </div>
                        </div>
                        <div class="col-md-4 mb-3">
                        <div class="card-wrapper">
                            <div class="card services gptw-space" onClick={openGptw}>
                                <div class="icon-placeholder greatplace">
                                    <div class="icon"></div>
                                </div>
                                <div class="title"><i class="counter" style={{"font-style":"normal"}} data-count="89">0</i>%</div>
                                <div class="sub-title">{t('home.numbers.greatplace')}</div>
                            </div>
                        </div>
                        </div>
                    </div>
                    </div>
                </section>
            </article>
    )
}